<template>
  <div class="px-2 mb-4">
    <h1 class="sm:text-2xl text-3xl font-bold title-font">
      {{ title_header }}
    </h1>
    <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
      {{ sub_header }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title_header: String,
    sub_header: String
  }
}
</script>

<style>
</style>
